import React from 'react';

function Sidenav(props){
    let style = {};
    let links;
    let frmStyle;
    let btnStyle;

    if(props.styles){

        style.backgroundColor = props.styles.sidebar.backgroundColor;
        style.color = props.styles.sidebar.color || "#FFF";
        style.border = props.styles.sidebar.border;
        style.btn = props.styles['btn-primary'] || "";
        style.buttonColor =  props.styles['btn-primary'] || "";
        if(style.btn){
            style.buttonBgColor = props.styles['btn-primary'].backgroundColor;
            style.buttonColor =  props.styles['btn-primary'].color;
        }else{
            style.buttonBgColor = "#FFF";
            style.buttonColor =  "#333";
        }
        
    }

    if(props.links){
       frmStyle = {      
            backgroundColor: style.backgroundColor,
            color: style.color,
            border : style.border,
            paddingTop : '1.5rem',
            paddingBottom : '1.5rem',
            paddingLeft : '1rem',
            paddingRight : '1rem',
            minHeight : "360px",
            height : "448px",
            overflowY : "auto",
            marginBottom : "15px"     
        }; 

        btnStyle = {
            backgroundColor: style.buttonBgColor,
            color: style.buttonColor
        }

        if(props.template === "LINKED_UP_LEFT" || props.template === "LINKED_UP" || props.template === "LINKED_UP_FOOTER" || props.template === "LINKED_UP_LEFT_FOOTER" || props.template === "LP_LINKS_WITH_ICONS"){
            btnStyle = {
                backgroundColor: "#FFF",
                color: "#333"
            }

        }
        links = props.links.map(function(link, index){
            if(!link.custom_button){
                return <li style={{marginBottom : "10px"}} key={index}><a style={btnStyle} href={link.link} className="btn btn-default btn-lg btn-block">{link.label}</a></li>
            }
        });

    }
    return (
        <div className="sidenav" style={frmStyle}>
        <ul className="list-unstyled">{links}</ul>
        </div>
    )

}

export default Sidenav;


// WEBPACK FOOTER //
// ./src/components/Sidenav.js